import React from 'react';

import { token } from '@atlaskit/tokens';

export const RovoLogo = (): React.JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7.74328 1.00957C8.3818 0.65712 9.16114 0.663595 9.79449 1.02899L15.9562 4.5864C16.601 4.95844 17.0002 5.64868 17.0002 6.39226V13.5072C17.0002 14.2537 16.6035 14.9409 15.9567 15.3128L11.3249 17.9869C11.335 17.9584 11.3447 17.9297 11.3539 17.9008C11.4399 17.6343 11.4855 17.3526 11.4855 17.0646V9.94972C11.4855 8.97229 10.9656 8.07094 10.1176 7.58334L6.66492 5.59083V2.8348C6.66492 2.61763 6.69849 2.40549 6.76203 2.20466C6.91822 1.71863 7.25043 1.29786 7.70491 1.0352L7.70629 1.0344C7.71932 1.02688 7.73171 1.01854 7.74328 1.00957Z"
			fill={token('color.icon.inverse')}
		/>
		<path
			d="M6.17528 1.91943L1.54352 4.59356C0.896734 4.9654 0.5 5.6526 0.5 6.39913V13.5141C0.5 14.2576 0.899073 14.9478 1.54394 15.3199L7.70569 18.8773C8.33903 19.2427 9.11841 19.2492 9.7569 18.8968C9.76847 18.8878 9.78078 18.8795 9.79381 18.872C10.2488 18.6095 10.5815 18.1886 10.7379 17.7023C10.8016 17.5013 10.8353 17.2889 10.8353 17.0715V14.3155L7.38278 12.3231C6.53497 11.8355 6.01472 10.9339 6.01472 9.95659V2.84167C6.01472 2.55414 6.06017 2.27283 6.14592 2.00659C6.15522 1.97735 6.16501 1.94829 6.17528 1.91943Z"
			fill={token('color.icon.inverse')}
		/>
	</svg>
);
